import { useEffect, useState } from 'react'
import { insights } from './api'
import { toRequestSpec } from './filterSpec'

const POLL_MS = 500

/**
 * Runs one breakdown request and polls it to completion. The scan is a job on the
 * server, so partial results stream in the same way filtered rows do.
 */
export function useInsights(datasetId, filters, dup, request) {
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  // Serialize the inputs so the effect only re-runs on a real change.
  const key = JSON.stringify({
    datasetId,
    filters: toRequestSpec(filters),
    dup: dup ?? null,
    request,
  })

  useEffect(() => {
    const { datasetId: id, filters: f, dup: scope, request: req } = JSON.parse(key)
    if (!id || !req?.columns?.length) {
      setResult(null)
      setError(null)
      return
    }
    let cancelled = false
    let timer = null
    setError(null)

    const tick = async () => {
      try {
        const next = await insights({
          id,
          filters: f,
          keyColumns: scope?.columns ?? null,
          mode: scope?.mode ?? null,
          // The same rules the table is using, so a breakdown of the
          // deduplicated rows counts the copies the rules actually kept.
          resolution: scope?.resolution ?? null,
          columns: req.columns,
          combine: req.combine,
          top: req.top ?? 25,
        })
        if (cancelled) return
        setResult(next)
        if (next.error) setError(next.error)
        else if (!next.done) timer = setTimeout(tick, POLL_MS)
      } catch (err) {
        if (!cancelled) setError(err.message)
      }
    }
    tick()
    return () => {
      cancelled = true
      if (timer) clearTimeout(timer)
    }
  }, [key])

  return { result, error }
}
